import { render } from "./TableHandler.vue?vue&type=template&id=2acb3162&scoped=true&ts=true"
import script from "./TableHandler.vue?vue&type=script&lang=ts"
export * from "./TableHandler.vue?vue&type=script&lang=ts"

import "./TableHandler.vue?vue&type=style&index=0&id=2acb3162&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acb3162"]])

export default __exports__